import { render, staticRenderFns } from "./PrintersDesktop.vue?vue&type=template&id=a4d0e058"
import script from "./PrintersDesktop.vue?vue&type=script&lang=js"
export * from "./PrintersDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports